import { render, staticRenderFns } from "./SellersCampaigns.vue?vue&type=template&id=606c649e&"
import script from "./SellersCampaigns.vue?vue&type=script&lang=ts&"
export * from "./SellersCampaigns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports